import { Typography } from '@material-ui/core'
import AppBar from '@material-ui/core/AppBar'
import { FormType, Route } from 'constants/'
import { supportedDeliveryModels } from 'constants/supportedDeliveryModels'
import { useFeatureFlags, useUser } from 'hooks'
import { useMatch } from 'react-router-dom'
import { useAppointmentGuidesTitle } from '../useAppointmentGuidesRoute'
import { DeliveryModelToggle } from './DeliveryModelToggle'
import { Home } from './Home'
import { useStyles } from './index.styles'
import { Search } from './Search'
import { NeoCustomerSearch } from './Search/NeoCustomerSearch'
import { UserItems } from './UserItems'

const formTypeToTitle: Record<FormType, string> = {
  [FormType.POST_APPOINTMENT]: 'Post Appointment Outcome Form',
}

const matchPath = `${Route.FORMS}/*`

const Header = () => {
  const match = useMatch(matchPath)
  const classes = useStyles()
  const { allowedDeliveryModels } = useUser()
  const appointmentGuidesTitle = useAppointmentGuidesTitle()
  const showDeliveryModelSelector =
    !appointmentGuidesTitle &&
    allowedDeliveryModels.filter((deliveryModel) => supportedDeliveryModels.has(deliveryModel)).length > 1
  const isMatch = Boolean(match)
  const [, , formType] = isMatch ? match?.pathname.split('/') ?? [] : [] // /forms/:type/:customerId
  const type = (formType ?? '').toLowerCase() as FormType
  const title = appointmentGuidesTitle ?? formTypeToTitle[type] ?? ''

  const [isNeoEnabled] = useFeatureFlags(['NEO'])

  const _Search = isNeoEnabled ? <NeoCustomerSearch /> : <Search />

  return (
    <AppBar className={classes.appBar}>
      <div className={classes.root}>
        <div className={classes.left}>
          <Home />
          {showDeliveryModelSelector && <DeliveryModelToggle />}
        </div>
        <div className={classes.centered}>
          {title ? <Typography className={classes.title}>{title}</Typography> : _Search}
        </div>
        <div className={classes.userItems}>
          <UserItems />
        </div>
      </div>
    </AppBar>
  )
}

export { Header }
